// kayitIstatistikleriService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL"; 
import { KayitIstatistikleriRequestModal } from "../../types/RequestModals/KayitIstatistikleriRequestModal";
import { KayitIstatistikleriResponseModal } from "../../types/modals";
import { KayitIstatistikleriError } from "../../types/ErrorModals/KayitIstatistikleriError";

export const getKayitIstatistikleri = async (request: KayitIstatistikleriRequestModal): Promise<KayitIstatistikleriResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<KayitIstatistikleriResponseModal>>(
      `${API_URL}/api/KayitIstatistikleri/getKayitIstatistikleri`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Kayıt istatistikleri bulunamadı",
          correlationId: responseData?.correlationId
        } as KayitIstatistikleriError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as KayitIstatistikleriError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as KayitIstatistikleriError;
    }
    
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as KayitIstatistikleriError;
  }
};